import React from "react";
import { motion } from "framer-motion";
import { skillsData } from "../../data";

function Skills() {
  return (
    <div className="flex relative flex-col text-center md:text-left xl:flex-row max-w-[2000px] xl:px-10 min-h-screen justify-center xl:space-y-0 mx-auto items-center z-0">
      <h3 className="absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl cursor-default ">
        Skills
      </h3>
      <motion.div
        initial={{
          x: 100,
          opacity: 0,
        }}
        whileInView={{
          x: 0,
          opacity: 1,
        }}
        transition={{
          duration: 1,
        }}
      >
        <div className="grid grid-cols-3 gap-7 mx-auto">
          {skillsData.map((skills, index) => (
            <div className="group relative flex cursor-pointer" key={index}>
              <img
                src={skills.imageLink}
                className="rounded-full border border-gray-500 object-cover w-24 h-24  p-2 xl:w-28 xl:h-28 group-hover:grayscale transition duration-300 ease-out"
                alt=""
              />
            </div>
          ))}
        </div>
      </motion.div>
    </div>
  );
}

export default Skills;
